import { vmodule, VueModule } from '@niknevis/vue-modules'
import { Obj, Router, Str, ZiggyService } from '@/modules/shared/helpers'

declare module 'vue/types/vue' {
  interface Vue {
    Str: Str,
    Ziggy: ZiggyService,
    Obj: Obj,
    Router: Router
  }
}

@vmodule()
export default class SharedModule extends VueModule {
  readonly name = 'SharedModule'

  services = {
    Str,
    Ziggy: ZiggyService,
    Obj,
    Router
  }
}
